import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type DropdownState = {
	open: boolean;
	position?: Vector2d | null,
	pointIndex?: number | null,
	segmentId?: string | null, 
	shadingModal:{
		type: 'adjust' | 'undo'| 'init'
		open: boolean
	},
	recalculateLayoutModalOpen: boolean,
	resetTranslations: boolean,
};

const initialState: { data: DropdownState } = {
	data: {
		open: false,
		shadingModal:{
			type: 'adjust',
			open: false
		},
		recalculateLayoutModalOpen: false,
		resetTranslations: false,
		pointIndex: null,
	}
};

export const EditFacetModalSlice = createSlice({
	name: 'editFacetModal',
	initialState,
	reducers: {
		setDropdownState(state, action: PayloadAction<Partial<DropdownState>>) {
			state.data.open= !!action.payload.open;
			state.data.position= action.payload.position || null;
			state.data.pointIndex = action.payload.pointIndex || null;
			state.data.segmentId = action.payload.segmentId || null;
		},
		toggleShadingModalState(state, action: PayloadAction<{ value: boolean, type: 'adjust' | 'undo' | 'init'}>) {
			state.data.shadingModal = {
				open: action.payload.value,
				type: action.payload.type
			};
		},
		toggleUndoShadingModalState(state, action: PayloadAction<{ value: boolean}>) {
			state.data.shadingModal = {
				open: action.payload.value,
				type: 'undo'
			};
		},
		toggleRecalculateLayoutModalState(state, action: PayloadAction<{ value: boolean}>) {
			state.data.recalculateLayoutModalOpen = action.payload.value;
		},
		toggleResetTranslationsModalState(state, action: PayloadAction<{ value: boolean}>) {
			state.data.resetTranslations = action.payload.value;
		},
	}
});

export const { setDropdownState, toggleShadingModalState, toggleUndoShadingModalState, 
	toggleRecalculateLayoutModalState, toggleResetTranslationsModalState } = EditFacetModalSlice.actions;

export default EditFacetModalSlice.reducer;